import LinearGradient from './linear-gradient';
import {LinearGradientProps} from './linear-gradient';
export type {LinearGradientProps};
export default LinearGradient;
